import FJMenuTab from '../../../../common/components/FJMenuTab/FJMenuTab';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJObjectEraseBrashContainer from '../container/FJObjectEraseBrashContainer';
import PropTypes from 'prop-types';
import FJObjectEraseTextContainer from '../container/FJObjectEraseTextContainer';

const MENU_LIST = [
    {
        text: 'custom-removal',
    },
    {
        text: 'prompt-removal',
    },
];

const FJObjectEraseLeft = ({ curMenuIndex, switchCurMenuIndex }) => {
    return (
        <FJAppLeft>
            {<FJMenuTab list={MENU_LIST} curIndex={curMenuIndex} onChange={switchCurMenuIndex} />}

            <FJObjectEraseBrashContainer isShow={curMenuIndex === 0} />
            <FJObjectEraseTextContainer isShow={curMenuIndex === 1} />
        </FJAppLeft>
    );
};

FJObjectEraseLeft.propTypes = {
    curMenuIndex: PropTypes.number,
    switchCurMenuIndex: PropTypes.func,
};

export default FJObjectEraseLeft;
